import { Card, CardContent, CardHeader, Collapse, makeStyles, Typography } from '@material-ui/core'
import { ExpandLessOutlined, ExpandMoreOutlined } from '@material-ui/icons'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { ListWithAddButtonMultiple } from '../Common/ListWithAddButtonMultiple'

const useStyles = makeStyles((theme) => ({
	header: {
		width: '100%',
		paddingRight: 24,
		paddingLeft: 0,
		borderRadius: 8,
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		cursor: 'pointer'
	},
	row: {
		width: '100%',
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		'& .MuiTextField-root, .MuiAutocomplete-root, .MuiFilledInput-root': {
			// width: 270,
			minWidth: 270
		},
		'& .MuiSvgIcon-root': {
			color: '#3B0275',
			fill: '#3B0275'
		}
	},
	input: {
		marginBottom: theme.spacing(2),
		width: '32%'
	},
	message: {
		fontSize: 14,
		fontWeight: '600',
		lineHeight: '19px',
		color: '#A2A1A4'
	},
	link: {
		color: '#6B4AD6',
		background: 'none',
		border: 'none',
		'& p': {
			fontSize: '12px',
			fontWeight: '600',
			lineHeight: '19px'
		},
		cursor: 'pointer'
	}
}))

const AddonCategories = (props) => {
	const classes = useStyles()
	let { selectedFacility, setCurrent } = props
	const [isExpanded, setIsExpanded] = useState(false)

	const updateFacility = (key, val) => {
		if (key === 'addons_categories') {
			// we are doing this because the list of addon categories is filtering the grooming_service
			const filtered = selectedFacility.addons_categories.filter((g) => g.grooming_service)
			val = [...filtered, ...val]
		}

		setCurrent({ ...selectedFacility, [key]: val })
	}

	return (
		<Card style={{ maxWidth: '1245px' }}>
			<div className={classes.header} onClick={() => setIsExpanded(!isExpanded)}>
				<CardHeader title="ENRICHMENT CATEGORIES" />
				<div style={{ cursor: 'pointer', display: 'flex' }}>
					{isExpanded ? (
						<ExpandLessOutlined style={{ fill: '#777679', cursor: 'pointer' }} />
					) : (
						<ExpandMoreOutlined style={{ fill: '#777679', cursor: 'pointer' }} />
					)}
				</div>
			</div>
			<Collapse
				in={isExpanded}
				timeout="auto"
				unmountOnExit
				style={{ background: 'transparent', cursor: 'default' }}>
				<CardContent>
					<ListWithAddButtonMultiple
						list={selectedFacility?.addons_categories.filter((a) => !a.grooming_service)}
						label1="Enrichment Category Name"
						label2="Enrichment Category Icon"
						label3="Enrichment Order"
						key1="name"
						key2="icon"
						key3="order"
						labeltoogle="Auto-Expanded Section"
						toogleKey="auto_expanded_section"
						showHelperTextKey1={true}
						showHelperTextKey2={false}
						showHelperTextKey3={false}
						onChange={(list) => {
							updateFacility('addons_categories', list)
						}}
						onDelete={(list) => {
							updateFacility('addons_categories', list)
						}}
						onAdd={(list) => {
							updateFacility('addons_categories', list)
						}}
						maxCharacters={50}
						addButtonLabel="Enrichment category"
						additionalMessage={
							<Typography className={classes.message}>
								Enter the icon name found on
								<Link
									className={classes.link}
									underline="none"
									component="button"
									variant="body2"
									onClick={() => {
										window.open('https://fontawesome.com/v5.15/icons?d=gallery&p=2&s=solid')
									}}>
									<Typography>Font Awesome’s Website.</Typography>
								</Link>
							</Typography>
						}
					/>
				</CardContent>
			</Collapse>
		</Card>
	)
}

export default AddonCategories
